export default __webpack_public_path__ + "locales/fr/JavascriptSdk.json?hash=971c9b122247333d0f3320b93cc157aa";